var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinDarkBlue = function SvgLinkedinDarkBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00586C",
    d: "M21.5 2H3.495C2.67 2 2 2.68 2 3.514v17.972C2 22.32 2.67 23 3.495 23H21.5c.825 0 1.5-.68 1.5-1.514V3.514A1.51 1.51 0 0 0 21.5 2M8.347 20H5.234V9.978h3.118V20zM6.79 8.61a1.805 1.805 0 0 1 0-3.61c.993 0 1.804.81 1.804 1.805 0 .998-.806 1.804-1.804 1.804M20.014 20h-3.112v-4.875c0-1.162-.024-2.658-1.618-2.658-1.622 0-1.87 1.266-1.87 2.574V20h-3.112V9.978h2.986v1.369h.042c.417-.788 1.434-1.617 2.948-1.617 3.15 0 3.736 2.076 3.736 4.776z"
  })));
};
export default SvgLinkedinDarkBlue;